import cx from 'classnames';
import {FC, MouseEventHandler, ReactNode} from 'react';
import {Button} from '~library/atoms/Button';

import './GiftCardButton.sass';

interface GiftCardButtonProps {
  disabled?: boolean;
  isBusy?: boolean;
  onClick: MouseEventHandler;
  text: string;
  desktopWide?: boolean;
  className?: string;
}

export const GiftCardButton: FC<GiftCardButtonProps> = ({
  disabled = false,
  isBusy = false,
  onClick,
  text,
  desktopWide,
  className = null,
}) => (
  <Button
    variant="primary"
    fullWidth={!desktopWide} // when used other than create flow, we need our custom css below
    size="large"
    data-qa-id="blocked-open-gift-card"
    disabled={disabled}
    onClick={onClick}
    className={cx(className, {
      'gift-card__button__full-width': desktopWide,
    })}
  >
    {isBusy ? <span className="evt-spinner inline" /> : <span className="bouncing-icon">🎁</span>}
    {text}
  </Button>
);

interface GiftCardBarProps {
  children: ReactNode;
}

export const GiftCardBar: FC<GiftCardBarProps> = ({children}) => (
  <div className="gift-card__button">{children}</div>
);
